import { createAction } from "redux-actions";

const GET_COMMITTEES = "COMMITTEES/get_all";
const GET_COMMITTEES_SUCCEEDED = "COMMITTEES/get_all_succeeded";

export const getCommittees = createAction(GET_COMMITTEES);
export const getCommitteesSucceeded = createAction(GET_COMMITTEES_SUCCEEDED);
